// ============================================================
//  English translations — en.ts
// ============================================================

import { NotificationType } from "../models/notification_type";

const en = {

  common: {
  save:        "Save changes",
  saving:      "Saving...",
  loading:     "Loading...",
  cancel:      "Cancel",
  confirm:     "Confirm",
  delete:      "Delete",
  edit:        "Edit",
  back:        "Back",
  search:      "Search",
  noResults:   "No results",
  error:       "Something went wrong",
  success:     "Operation successful",
  copyEmail:   "Copy email",
  copied:      "Copied!",
  yes:         "Yes",
  no:          "No",
  saveConfirmTitle: "Confirm save",
    continue: "Continue",
    deleteConfirmTitle: "Confirm deletion",
  logoutTitle: "Sign out?",
  logoutContent: "Are you sure you want to sign out of your account?",
  logoutConfirm: "Sign out",
},
resiliation: {
    warningTitle: "Leave Notacito",
    warningDesc1: "This action is",
    warningDescIrreversible: "irreversible",
    warningDesc2: ". It will result in the",
    warningDescImmediate: "immediate cancellation",
    warningDesc3: "of your subscription and the",
    warningDescClosure: "permanent closure",
    warningDesc4: "of your account.",
    warningPoint1: "Your active subscription is canceled without a prorated refund",
    warningPoint2: "Access to all Notacito features is revoked immediately",
    warningPoint3: "All members of your company lose their access",
    warningPoint4: "You choose what happens to your data in the next step",

    step1Label: "Step 1 of 2",
    dataChoiceTitle: "What to do with your data?",
    dataChoiceDesc: "Choose what happens to all data associated with your account (files, history, reports, settings).",
    keepDataTitle: "Keep my data",
    keepDataDesc1: "Your data remains archived indefinitely. You can request an export at any time by writing to",
    deleteDataTitle: "Delete all my data",
    deleteDataDesc1: "All your data is",
    deleteDataDescStrong: "permanently and irreversibly deleted",
    deleteDataDesc2: ". No recovery is possible after confirmation.",

    step2Label: "Step 2 of 2 — Final confirmation",
    confirmDeleteTitle: "Confirm deletion",
    confirmKeepTitle: "Confirm cancellation",
    confirmDeleteDesc1: "You have chosen to",
    confirmDeleteDescStrong: "permanently delete",
    confirmDeleteDesc2: "all your data. To confirm, type",
    confirmDeleteDesc3: "below.",
    confirmKeepDesc1: "You have chosen to",
    confirmKeepDescStrong: "keep your data",
    confirmKeepDesc2: ". It will remain archived and exportable upon request. By clicking \"Confirm\", your account will be permanently closed.",

    summaryResiliation: "Cancellation",
    summaryImmediate: "Immediate",
    summaryData: "Data",
    summaryDataDeleted: "Permanently deleted",
    summaryDataKept: "Kept & exportable",

    confirmingBtn: "Confirming...",
    confirmLeaveBtn: "Confirm and leave",

    doneTitle: "Your account has been closed",
    doneMessageDeleted: "All your data has been deleted. Thank you for using Notacito.",
    doneMessageKept: "Your account is closed. Your data is retained — contact us at any time for an export.",
    redirecting: "You will be automatically logged out in a few moments…"
  },

featureGate: {
  subscriptionRequired: "Subscription required",
  featureName: "Premium Feature",
  unlock: "Unlock ",
  upgrade: "View offers",
  neededPlan: "You need to subscribe to a plan to access this page.",
  morePlan: "Upgrade to a higher plan to access this feature.",
},

topHeader: {
  activateTrial: "Activate my free trial",
},

  nav: {
  dashboard: "Dashboard",
  members: "Members",
  users: "Users",
  admins: "Admins",
  accountants: "Accountants",
  clients: "Clients",
  expenses: "Expense reports",
  categories: "Categories",
  offices: "Offices",
  companyPolicies: "Company policies",
  corporate: "Corporate",
  settings: "Settings",

  account: "My account",
  manageSubscription: "Manage subscription",
  logout: "Sign out",
  help: "Help",
    openMenu: "Open menu",
notacitoLogo: "Notacito logo",
  profileOverview: "Profile overview",
  options: "Options",
  defaultUser: "User",

  expandMenu: "Expand menu",
  collapseMenu: "Collapse menu",

  plusDescription:
    "Unlock all administration features.",
  viewOffer: "View offer",
},

  account: {
    pageTitle:          "Manage my account",
    sidebarLabel:       "Manage my account",
    myAccount:          "My account",
    security:           "Security",
    manageSubscription: "Manage subscription",
    myProfile:          "My profile",
    firstName:          "First name",
    lastName:           "Last name",
    myEmail:            "My email",
    verified:           "✓ VERIFIED",
    phone:              "Phone",
    phonePlaceholder:   "+1 555 000 0000",
    toastSuccess:       "Profile updated!",
    toastError:         "Error: ",
  },

  preferences: {
    title:      "Preferences",
    language:   "Language",
    theme:      "Theme",
    lightMode:  "Light mode",
    darkMode:   "Dark mode",
  },

  security: {
    title:        "Security",
    description:  "Manage your administrator account security.",
    password:     "Password",
    lastModified: "Last modified: unknown",
    dangerZone:   "Danger zone",
    dangerDesc:   "Irreversible actions on your account.",
    logout:       "Sign out",
  },

  subscription: {
    title:          "My subscription",
    description:    "Manage your plan and billing options.",
    freePlanDesc:   "You are on the free plan. Upgrade to Notacito Plus to unlock all features.",
    activePlanDesc: "Your subscription is active. Thank you for your trust!",
    upgradeCta:     "⭐ Upgrade to Plus",
    status:         "Status",
    plan:           "Plan",
    billingPeriod: "Billing period",
    monthlyBilling: "Monthly",
    yearlyBilling: "Yearly",
    resiliationZoneTitle: "Leave Notacito",
    resiliationZoneDesc: "Permanently close your account and choose what happens to your data. This action is irreversible.",
    resiliationCta: "Cancel and leave Notacito",
      resiliationCompany: "Company to cancel",
    chooseCompany: "Choose a company",
    cancelZoneTitle: "Cancel subscription",
    cancelZoneDesc: "You will retain access until the end of your current billing period.",
    cancelCta: "Cancel my subscription",
    cancelSuccess: "Your subscription will be canceled at the end of the current period.",
    cancelError: "Error canceling subscription: ",
    scheduledCancellation: "Your subscription will be canceled at the end of the current period and will not be renewed.",
cancelConfirmTitle: "Cancel your subscription?",
cancelConfirmContent: "You will retain access until the end of your current billing period. Confirm this cancellation?",
cancelConfirmBtn: "Confirm Cancellation",
    plans: {
      free:       "Free",
      essential:  "Essential",
      pro:        "Pro",
      enterprise: "Enterprise",
    },
  },

  dashboard: {
    title:            "Dashboard",
    subtitle:         "Overview of key statistics and financial activity.",
    loading:          "Loading dashboard data...",
    errorLoading:     "Error loading data. Please try again.",
    totalMembers:     "Total Members",
    activeCategories: "Active Categories",
    expenseReports:   "Expense Reports",
    chartByType:      "Distribution by Type",
    chartByUsers:     "User Distribution",
    chartByStatus:    "Expense Report Statuses",
    chartOverTime:    "Spending over time (€)",
    tooltipAmount:    "{b} : {c} €",
    unknownRole:      "Unknown",
    unknownStatus:    "UNKNOWN",
  },

  home: {
    title: "Users",
    subtitle: "Manage all users, grouped by company.",
    totalUsers: "Total users",
    companies: "Companies",
    active: "Active",
    blocked: "Blocked",
    left: "Left",
    searchPlaceholder: "Search by name, email, role…",
    noUsersFound: "No users found.",
    noSearchMatch: "No users match your search.",
    failedToLoad: "Failed to load users:",
    userStatusUpdated: "User status updated.",
    blockUser: "Block user",
    activateUser: "Activate user",
    usersCount: "user",
    usersCountPlural: "users",
    table: {
      name: "Name",
      email: "Email",
      role: "Role",
      phone: "Phone",
      status: "Status",
      access: "Access"
    },
    page: "Page"
  },
  updateExpenseStatus: {
    title: "Update Expense Status",
    currentStatus: "Current status:",
    confirmTransition: "Are you sure you want to set this report to {status}?",
    updateSuccess: "Expense report updated to {status}",
    updateError: "Failed to update status",
    approve: "Approve",
    reject: "Reject",
    markReimbursed: "Mark as reimbursed",
    noTransition: "No status transition available for this expense report.",
    back: "Back",
    loading: "Loading expense report...",
    error: "Error: ",
    notFound: "Expense report not found",
  },
  
  users: {
    unnamed: "Unnamed",
    edit: "Edit",
    uid: "Firebase UID",
    copyUid: "Copy UID",
    phone: "Phone",
    company: "Company",
    role: "Role",
    iban: "IBAN",
    gender: "Gender",
    birthDate: "Birth Date",
    address: "Address",
    loading: "Loading user...",
    errorLoading: "Error: ",
    notFound: "User not found.",
    cannotLoad: "Cannot load user.",
    client: "Client",
    accountant: "Accountant",
    admin: "Admin",
    updated: "User updated.",
    updateError: "Error during update.",
    deleteConfirm: "Permanently delete {name}?",
    deleted: "User deleted.",
    deleteError: "Error during deletion.",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    selectRole: "Select a role",
    selectGender: "Select",
    male: "Male",
    female: "Female",
    other: "Other",
    deleting: "Deleting...",
    deleteBtn: "Delete",
    cancelBtn: "Cancel",
    saving: "Saving...",
    saveBtn: "Save",
     saveConfirmTitle: "Confirm save",
    saveConfirmContent: "Are you sure you want to save the changes made to this user?",
    deleteConfirmTitle: "Confirm deletion",
    ibanLengthError: "The IBAN must contain exactly 21 characters.",
    ibanMissingChars: "Missing {count} character(s).",
  },
  searchPlaceholderCompany: "Search by name, email, company…",
  pagination: {
    result: "result",
    results: "results",
  },
  clients: {
    title: "Clients",
    subtitle: "Manage your clients and their information.",
    addBtn: "Add Client",
    total: "Total clients",
    block: "Block client",
    activate: "Activate client",
    noMatch: "No clients match your search.",
    notFound: "No clients found.",
    statusUpdated: "Client status updated.",
    failedToLoad: "Failed to load clients:",
    count: "client",
    countPlural: "clients",
    clientManagement: "the management of clients",
    limitExceededEmployee: "Employee limit reached for this subscription. Please upgrade to a higher plan."
  },
  accountants: {
    title: "Accountants",
    subtitle: "Manage your accountants and their information.",
    addBtn: "Add Accountant",
    total: "Total accountants",
    block: "Block accountant",
    activate: "Activate accountant",
    noMatch: "No accountants match your search.",
    notFound: "No accountants found.",
    statusUpdated: "Accountant status updated.",
    failedToLoad: "Failed to load accountants:",
    count: "accountant",
    countPlural: "accountants",
    accountantManagement: "the management of accountants",
    limitExceededEmployee: "Employee limit reached for this subscription. Please upgrade to a higher plan."

  },
  admins: {
    title: "Admins",
    subtitle: "Manage your admins and their information.",
    addBtn: "Add Admin",
    total: "Total admins",
    block: "Block admin",
    activate: "Activate admin",
    noMatch: "No admins match your search.",
    notFound: "No admins found.",
    statusUpdated: "Admin status updated.",
    failedToLoad: "Failed to load admins:",
    count: "admin",
    countPlural: "admins",
    adminManagement: "the management of admins",
    limitExceededEmployee: "Employee limit reached for this subscription. Please upgrade to a higher plan."
  },

  expenseReports: {
    title: "Expense Reports",
    subtitle: "Manage expenses grouped by company and employee.",
    noCompany: "No company",
    unknownUser: "Unknown",
    statusDraft: "Draft",
    statusPending: "Pending",
    statusApproved: "Approved",
    statusReimbursed: "Reimbursed",
    statusRejected: "Rejected",
    pendingAlertSingle: "pending expense",
    pendingAlertPlural: "pending expenses",
    pendingLabel: "pending",
    approvedAlertSingle: "approved expense",
    approvedAlertPlural: "approved expenses",
    approvedLabel: "approved",
    noAlerts: "No alerts",
    monthTotal: "Month total",
    noExpenses: "No expenses",
    reportCountSingle: "report",
    reportCountPlural: "reports",
    userCountSingle: "user",
    userCountPlural: "users",
    noExpensesThisMonth: "No expenses this month.",
    showingExpensesFor: "Showing expenses for",
    only: "only",
    noUsersMatch: "No users match your search.",
    showingSearchMatch: "Showing this month's expenses for users matching",
    noReportsFound: "No expense reports found.",
    tableSupplier: "Supplier",
    tableCategory: "Category",
    tableDate: "Date",
    tableAmount: "Amount",
    tableVat: "VAT",
    tableStatus: "Status",
    statTotalReports: "Total reports",
    statCompanies: "Companies",
    statMonthTotal: "Month total",
    statPending: "Pending",
    statApproved: "Approved",
    statReimbursed: "Reimbursed",
    searchPlaceholder: "Search by employee name or email → shows their monthly expenses",
    failedToLoad: "Failed to load expense reports:",
     filterTitle:          "Filter",
    filterClear:          "Reset",
    filterAll:            "All",
    filterYear:           "Year",
    filterMonth:          "Month",
    filterCategory:       "Category",
    filterStatus:         "Status",
  },

  categoryTypes: {
  standard: "Standard",
  meal: "Meal",
  housing: "Housing",
  travel: "Travel",
  office: "Office",
  training: "Training",
  provider: "Provider",
  vehicle: "Vehicle",
  equipment: "Equipment",
  fuel: "Fuel",
  phone: "Phone",
  pressing: "Pressing",
  other: "Other"
},

categoryDetails: {
  unnamed: "Unnamed",
  noCompany: "No company",
  cancel: "Cancel",
  deleteCategory: "Delete category",
  editCategory: "Edit category",
  deleteConfirm:
    'Are you sure you want to delete category "{name}"?',
  deleteSuccess: "Category deleted successfully.",
  deleteError: "Failed to delete category.",
},

patchCategory: {
  title: "Edit category",
  categoryType: "Category type",
  loading: "Loading...",
  cancel: "Cancel",
  saving: "Saving...",
  saveChanges: "Save changes",
  fetchError: "Error fetching category.",
  updateSuccess: "Category updated successfully.",
  updateError: "Error updating category: {message}",
},


addUserForm: {
  roles: {
    client: {
      title: "Add client",
      create: "Create client",
      success: "Client {name} created successfully.",
      error: "An error occurred while creating the client: {message}",
    },
    admin: {
      title: "Add administrator",
      create: "Create administrator",
      success: "Administrator {name} created successfully.",
      error: "An error occurred while creating the administrator: {message}",
    },
    accountant: {
      title: "Add accountant",
      create: "Create accountant",
      success: "Accountant {name} created successfully.",
      error: "An error occurred while creating the accountant: {message}",
    },
  },

  targetCompany: "Target company",
  platform: "Platform",
  noCompanies: "No companies available",

  firstName: "First name",
  lastName: "Last name",
  email: "Email",
  password: "Password",
  phoneNumber: "Phone number",
  optional: "optional",

  placeholders: {
    firstName: "Enter first name",
    lastName: "Enter last name",
    email: "Enter email",
    password: "Enter password",
    phoneNumber: "Enter phone number",
  },

  cancel: "Cancel",
  creating: "Creating...",
  loading: "Loading form details...",

  requiredFields:
    "Please fill in the first name, last name, email and password.",
  selectCompany: "Please select a company.",
  initializationError:
    "Failed to load the information required by the form.",
  unknownError: "Unknown error",
},


addCategory: {
  title: "Add new category",
  targetCompany: "Target company",
  categoryType: "Category type",
  platform: "Platform",
  cancel: "Cancel",
  creating: "Creating...",
  createCategory: "Create category",
  loading: "Loading form details...",
  selectCompany: "Please select a target company.",
  requirementsError:
    "Failed to load the information required by the form.",
  createSuccess: "Category created successfully.",
  createError: "Error creating category: {message}",
},

categoriesPage: {
  title: "Categories",

  accountantSubtitle:
    "View the categories available for your company.",
  managementSubtitle:
    "Manage your categories and their information.",

  addCategory: "Add category",

  totalCategories: "Total categories",
  companiesAffected: "Companies affected",

  searchPlaceholder:
    "      Search categories by type or name...",

  noCategories: "No categories found.",
  noSearchMatch:
    "No categories match your search.",

  noCompany: "Global / No company",

  typeName: "Type / Name",

  categorySingle: "category",
  categoryPlural: "categories",

  page: "Page",

  loadingError:
    "Failed to load categories: {message}",
  unknownError: "Unknown error",

  featureName: "category management",
},

  expenseReportDetails: {
  title: "Expense report",

  loading: "Loading expense report...",

  errors: {
    generic: "Error: {message}",
    notFound: "Expense report not found.",
    attachmentsNotFound: "Attachments not found.",
  },

  status: {
    draft: "Draft",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    reimbursed: "Reimbursed",
  },

  sections: {
    items: "Expense items",
    attachments: "Attachments",
  },

  fields: {
    amount: "Amount",
    receiptNumber: "Receipt number",
    expenseDate: "Expense date",
    vatAmount: "VAT amount",
    submittedAt: "Submitted at",
    comment: "Comment",
    distance: "Distance",
    vehiclePower: "Vehicle power",
    vehicleType: "Vehicle type",
    energyType: "Energy type",
    mileageRateYear: "Mileage rate year",
    calculatedReimbursement: "Calculated reimbursement",
    participants: "Participants",
    company: "Company",
    user: "User",
    category: "Category",
  },

  itemFields: {
    type: "Type",
    quantity: "Quantity",
    unitAmountTtc: "Unit price incl. tax",
    totalAmountTtc: "Total incl. tax",
    vatRate: "VAT rate",
    vatAmount: "VAT amount",
    amountHt: "Amount excl. tax",
    vatRecoverable: "Recoverable VAT",
  },

  actions: {
    approve: "Approve",
    reject: "Reject",
    markAsReimbursed: "Mark as reimbursed",
    openFull: "Open full size",
    download: "Download",
  },

  empty: {
    items: "No items found.",
    attachments: "No attachments found.",
  },

  attachments: {
    receiptAlt: "Expense receipt",
    loadingPreview: "Loading preview...",
  },

  confirm: {
    deleteReport:
      "Are you sure you want to delete this expense report?",
    deleteItem:
      "Are you sure you want to delete this expense item?",
    changeStatus:
      "Are you sure you want to change the status to “{status}”?",
  },

  alerts: {
    reportDeleted:
      "Expense report deleted successfully.",
    reportDeleteError:
      "Failed to delete the expense report.",
    itemDeleted:
      "Expense item deleted successfully.",
    itemDeleteError:
      "Failed to delete the expense item.",
    attachmentOpenError:
      "Failed to open the attachment.",
    statusUpdated:
      "The expense report is now “{status}”.",
    statusUpdateError:
      "Failed to update the expense report status.",
  },

  fileSize: {
    bytes: "B",
    kilobytes: "KB",
    megabytes: "MB",
  },

  // itemTypes: {
  //   standard: "Standard",
  // meal: "Meal",
  // housing: "Housing",
  // travel: "Travel",
  // office: "Office",
  // training: "Training",
  // provider: "Provider",
  // vehicle: "Vehicle",
  // equipment: "Equipment",
  // fuel: "Fuel",
  // phone: "Phone",
  // pressing: "Pressing",
  // other: "Other"
  // },

  vehicleTypes: {
    car: "Car",
    motorcycle: "Motorcycle",
    scooter: "Scooter",
    bicycle: "Bicycle",
  },

  energyTypes: {
    petrol: "Petrol",
    gasoline: "Gasoline",
    diesel: "Diesel",
    electric: "Electric",
    hybrid: "Hybrid",
    lpg: "LPG",
  },
},

settingsForm: {
  pageTitle: "Settings",
  selectCompany: "Select a company",
  chooseCompany: "Choose a company",
  selectCompanyPrompt: "Please select a company to manage its settings.",
  gamification: {
    title: "⚙️ Gamification",
    description:
      "Configure the engagement leaderboard for your team's expense reports.",

    enabledLabel: "Enable gamification",
    enabledDescription:
      "Enables or disables the leaderboard and flame rewards.",

    deadlineLabel: "Deadline day",
    deadlineDescription:
      "The day of the month when expense reports are expected, for example 10.",
  },

  mileageRates: {
  title: "Mileage Rates",
  description: "Configure the reimbursement rates based on vehicle type, power, and distance.",

  mode: {
    notacitoTitle: "Notacito Rates",
    customTitle: "Custom Rates",
    notacitoDescription:
      "Updates published by Notacito are automatically applied to this company.",
    customDescription:
      "This company uses its own rates. When no custom rate matches, the Notacito rate can be used as a fallback.",
    switchToCustom: "Customize rates",
    switchToNotacito: "Use Notacito rates",
    updating: "Updating...",
    switchToNotacitoSuccess: "Notacito rates are now in use",
    switchToCustomSuccess: "Custom rates are now enabled",
    switchError: "Failed to change rate mode: {message}",
    noCompanySelected: "No company selected",
    managedByNotacito: "Managed by Notacito",
    toggleTitleEditable: "Click to toggle status",
    toggleTitleLocked: "This rate is managed by Notacito",
  },

  nationalDefaultOption: "— National / Default Rates —",

  addRate: "Add Rate",
  ratesCountLabel: "rate(s) for {year}",
  activeCountLabel: "active",

  columnEnergy: "Energy",
  columnPower: "CV (min–max)",
  columnDistance: "Distance (km)",
  columnFixed: "Fixed",
  columnPerKm: "Per km",
  columnStatus: "Status",
  columnActions: "Actions",
  allEnergies: "All",
  statusActive: "Active",
  statusInactive: "Inactive",
  edit: "Edit",
  delete: "Delete",

  noRates: "No mileage rates configured for this year.",
  noNotacitoRates: "No Notacito rates configured for this year.",
  noCustomRates: "No custom rates configured for this year.",

  loading: "Loading rates...",

  vehicleTypes: {
    car: "Car",
    motorbike: "Motorbike",
    moped: "Scooter / Moped",
  },

  energyTypes: {
    thermal: "Thermal / Hybrid / Hydrogen",
    electric: "Electric",
    hybrid: "Hybrid",
    hydrogen: "Hydrogen",
  },

  modalCreateTitle: "New Mileage Rate",
  modalEditTitle: "Edit Rate",
  modalClose: "Close",

  fieldYear: "Year",
  fieldVehicleType: "Vehicle Type",
  fieldEnergyType: "Energy",
  fieldAllEnergies: "All energies",
  fieldStatus: "Status",

  sectionPower: "Fiscal Power (CV)",
  sectionDistance: "Distance Traveled (km)",
  sectionAmounts: "Amounts",

  fieldMin: "Min",
  fieldMax: "Max",
  fixedAmount: "Fixed Amount (€)",
  perKmAmount: "Amount per km (€)",

  previewLabel: "Example: for {distance} km, reimbursement ≈ {amount} €",

  cancel: "Cancel",
  saveRate: "Create Rate",
  updateRate: "Update",
  saving: "Saving...",

  errors: {
    yearInvalid: "Invalid year",
    vehicleTypeRequired: "Vehicle type is required",
    mustBePositive: "Must be ≥ 0",
    maxMustBeGreaterThanMin: "Max must be ≥ min",
  },

  deleteConfirmTitle: "Delete this rate?",
  deleteConfirmMessage:
    "The {vehicleType} rate ({powerMin}-{powerMax} CV) will be permanently deleted.",
  deleteConfirmBtn: "Delete",

  saveSuccess: "Rate saved successfully",
  saveError: "Failed to save: {message}",
  statusUpdateError: "Failed to update status: {message}",
  deleteSuccess: "Rate deleted",
  deleteError: "Failed to delete: {message}",
},

  saving: "Saving...",
  saveChanges: "Save changes",

  updateSuccess: "Settings updated successfully!",
  updateError: "Update error: {message}",

  featureName: "gamification management",
},


editExpenseReport: {
  title: "Edit expense report",
  subtitle: "Update the expense report information.",

  fields: {
    supplierName: "Supplier name",
    receiptNumber: "Receipt number",
    expenseDate: "Expense date",
    comment: "Comment",
    distanceKm: "Distance (km)",
    vehiclePowerCv: "Vehicle power (CV)",
    vehicleType: "Vehicle type",
    energyType: "Energy type",
    mileageRateYear: "Mileage rate year",
    participantCount: "Participant count",
  },

  placeholders: {
    supplierName: "Supplier name",
    receiptNumber: "Receipt number",
    optionalComment: "Optional comment",
    vehicleType: "CAR, MOTORBIKE...",
    energyType: "FUEL, ELECTRIC...",
    mileageRateYear: "2026",
    zero: "0",
  },

  cancel: "Cancel",
  saving: "Saving...",
  saveChanges: "Save changes",

  success: "Expense report updated successfully.",
  error: "Failed to update expense report.",
},

officeDetailsCard: {
  structureType: "Structure type",
  platformSystem: "🛡️ Platform system",
  clientCompany: "🏢 Client company",
  id: "ID",
  cancel: "Cancel",
  deleteOffice: "Delete office",
  deleteConfirm: 'Are you sure you want to delete office "{name}"?',
  deleteSuccess: "Office deleted successfully.",
  deleteError: "Failed to delete office.",
},

addOffice: {
  title: "Add new office",
  officeName: "Office name",
  officeNamePlaceholder: "Enter corporate or client name",
  isMainPlatform: "Is this the main Notacito platform?",
  cancel: "Cancel",
  creating: "Creating...",
  createOffice: "Create office",
  nameRequired: "Office name is required.",
  createSuccess: "Office created successfully.",
  createError: "Error creating office: {message}",
},

editExpenseReportItem: {
  title: "Edit expense item",
  subtitle: "Update the expense item information.",

  fields: {
    label: "Label",
    itemType: "Item type",
    quantity: "Quantity",
    unitAmountTtc: "Unit amount incl. tax",
    totalAmountTtc: "Total incl. tax",
    vatRate: "VAT rate",
    vatAmount: "VAT amount",
    amountHt: "Amount excl. tax",
    vatRecoverable: "Recoverable VAT",
    comment: "Comment",
  },

  itemTypes: {
    standard: "Standard",
  meal: "Meal",
  housing: "Housing",
  travel: "Travel",
  office: "Office",
  training: "Training",
  provider: "Provider",
  vehicle: "Vehicle",
  equipment: "Equipment",
  fuel: "Fuel",
  phone: "Phone",
  pressing: "Pressing",
  other: "Other"
  },

  yes: "Yes",
  no: "No",
  cancel: "Cancel",
  saving: "Saving...",
  save: "Save item",

  success: "Expense item updated successfully.",
  error: "Failed to update expense item.",
},



  offices: {
    title: "Offices",
    subtitle: "Manage your company's offices",
    loading: "Loading offices...",
    errorLoading: "Error loading offices:",
    noOffices: "No offices available.",
    addBtn: "Add Office",
  },

  officeCell: {
    noName: "Unnamed",
    mainPlatform: "Main Platform",
    standardCorporate: "Standard Corporate",
  },
  officeDetails: {
    loading: "Loading office details...",
    errorPrefix: "Error: ",
    notFound: "Office not found.",
  },
  companyPolicies: {
    title: "Company Policies",
    loading: "Loading policies...",
    deleteSuccess: "Policy deleted successfully",
    deleteConfirm: "Are you sure you want to delete this policy?",
    addBtn: "Add Policy",
    deleting: "Deleting...",
    deleteBtn: "Delete Policy",
    editBtn: "Edit Rules",
    status: "Status",
    dailyLimit: "Daily Limit",
    vatRule: "Vat Rule",
    receiptRequired: "Receipt Required",
    manualVat: "Manual VAT",
    selectCompany: "Select a company",
    chooseCompany: "Choose a company",
    active: "Active",

    allowed: "Allowed ✅",
    forbidden: "Forbidden ❌",
    noLimit: "No limit",
    yes: "Yes",
    no: "No",
    selectCategory: "Select a category to view details.",
    featureName: "the management of company policies",

  },

  companyPolicyForm: {
  editTitle: "Edit policy",
      saveConfirmContent: "Are you sure you want to save these changes?",

  editSubtitle:
    "Adjust the limits and requirements for this expense category.",

  createTitle: "Create a new policy",
  createSubtitle:
    "Configure a new expense rule for your company.",

  loading: "Loading...",

  fields: {
    category: "Select category",
    spendingLimit: "Spending limit (€)",
    maxWithoutReceipt: "Maximum without receipt (€)",
    vatRuleType: "VAT rule type",
    status: "Status",
  },

  placeholders: {
    chooseCategory: "Choose a category",
    noLimit: "No limit",
    zero: "0",
  },

  vatRules: {
    none: "None",
    manual: "Manual",
    sumLines: "Sum of lines",
  },

  statuses: {
    active: "Active",
    inactive: "Inactive",
  },

  conditionsTitle: "Conditions and receipts",

  conditions: {
    allowed: "Allowed",
    requiresReceipt: "Requires receipt",
    allowsVat: "Allows VAT",
    allowsManualVat: "Allows manual VAT",
    requiresComment: "Requires comment",
    requiresSupplierName: "Requires supplier name",
    allowsDistanceKm: "Allows mileage",
    allowsFuelExpense: "Fuel expense",
    allowCompanyCar: "Company car",
    allowPersonalCar: "Personal car",
  },

  cancel: "Cancel",
  saving: "Saving...",
  saveChanges: "Save changes",
  creating: "Creating...",
  createPolicy: "Create policy",

  updateSuccess: "Policy updated successfully.",
  updateError: "Failed to update policy: {message}",
  createSuccess: "Policy created successfully.",
  createError: "Failed to create policy: {message}",
  loadError: "Failed to load policy.",
  categoriesLoadError: "Failed to load categories.",
},

  corporate: {
    loading: "Loading corporate statistics...",
    errorLoading: "Failed to load statistics. Please try again.",
    title: "Corporate Engagement",
    subtitle: "Track team punctuality and expense report engagement.",
    statActive: "Active Employees",
    statTopStreak: "Top Streak",
    statTotalFlames: "Total Team Flames",
    liveLeaderboard: "🏆 Live Leaderboard",
    liveBadge: "Live",
    noActiveParticipants: "No active participants yet.",
    historicalPodium: "📊 Historical Podium",
    btnSnapshot: "📸 Snapshot",
    btnSaving: "Saving...",
    snapshotSuccess: "Leaderboard snapshot saved for",
    snapshotError: "Error saving:",
    snapshotConfirm: "Do you want to freeze the current leaderboard for month {month}/{year}? This will overwrite existing history for this month.",
    noDataRecorded: "No data recorded for this month.",
    howItWorksTitle: "💡 How it works",
    howItWorksL1: "Earn flames: Employees earn 1 flame maximum per month by submitting their expenses before the company's deadline.",
    howItWorksL2: "Penalties: Missing a deadline results in losing 1 flame (you don't lose everything at once!).",
    howItWorksL3: "Milestones: Keep the streak going up to a maximum of 12 flames to unlock exclusive badges (Bronze at 4, Silver at 8, Gold at 12).",
    howItWorksL4: "History: The podium is snapshotted on the last day of each month.",
    chartTitle: "Top 10 of the month"
  },

  upgrade: {
  back: "Back",
  ratingText: "Expense management made simple",
  title: "Choose the right plan for",
  titleHighlight: "your company",
  subtitle:
    "Centralize, approve and track your employees' expense reports from a single platform.",

  monthly: "Monthly",
  yearly: "Yearly",
  yearlyDiscount: "-10%",
  tooManyEmployees: "The number of employees exceeds the limit for this plan. Please choose a higher plan.",

  mostPopular: "MOST POPULAR",
  perMonth: "/ month",
  billed: "Billed",
  perYear: "per year",
  noPaymentRequired: "No payment method required",

  redirecting: "Redirecting...",
  continueFree: "Continue for free",
  choosePlan: "Choose this plan",

  errors: {
    planNotConfigured:
      "This plan has not yet been configured for payment.",
    checkoutUrlMissing:
      "Payment URL could not be found.",
    checkoutFailed:
      "Unable to open the payment page. Please try again.",
  },

  reassurance: {
    securePaymentTitle: "Secure payment",
    securePaymentText:
      "Payments will be processed by Stripe.",
    noCommitmentTitle: "No commitment",
    noCommitmentText:
      "You can cancel your subscription.",
    helpTitle: "Need help?",
    helpText:
      "Our team will support you during setup.",
  },

  plans: {
    free: {
      name: "Discovery",
      description:
        "Discover Notacito with limited access to features.",
      features: {
        employees: "Up to 1 employee",
        expenses: "36 receipt scans per year (unlimited manual entries)",
        manualCreation: "Manual expense creation",
        automaticScan:
          "Automatic receipt scanning",
        validation: "Expense report approval",
        accountingExports: "Accounting exports",
        prioritySupport: "Priority support",
      },
    },

    essential: {
      name: "Essential",
      description:
        "For small businesses looking to centralize their expenses.",
      features: {
        employees: "Up to 10 employees",
        expenses:
          "Up to 2,400 receipt scans per year (unlimited manual entries)",
        automaticScan:
          "Automatic receipt scanning",
        validation: "Approval workflow",
        accountingExports: "Accounting exports",
        dashboard: "Administrator dashboard",
        emailSupport: "Email support",
      },
    },

    business: {
      name: "Business",
      description:
        "The complete solution for efficiently managing your team's expenses.",
      features: {
        employees: "Up to 30 employees",
        expenses:
          "Up to 7,200 receipt scans per year (unlimited manual entries)",
        automaticScan:
          "Automatic receipt scanning",
        advancedValidation:
          "Advanced approval workflows",
        accountingExports: "Accounting exports",
        roles:
          "Role and permission management",
        prioritySupport: "Priority support",
      },
    },

    enterprise: {
      name: "Enterprise",
      description:
        "A solution designed for companies with greater requirements.",
      features: {
        employees: "Up to 50 employees",
        expenses:
          "Up to 12,000 receipt scans per year (unlimited manual entries)",
        businessFeatures:
          "All Business features",
        personalSupport:
          "Personalized assistance",
        bulkImport: "Bulk employee import",
        customConfiguration:
          "Custom configuration",
        dedicatedSupport:
          "Dedicated priority support",
      },
    },
}
},

notifications: {
  title: "Notifications",
  subtitle: "Manage your alerts and your company's activity.",

  markAllAsRead: "Mark all as read",
  markingAllAsRead: "Updating...",
  close: "Close and go back",

  tabs: {
    all: "All",
    unread: "Unread",
  },

  loading: "Loading your notifications...",

  emptyTitle: "No notifications",
  emptyMessage: "You're all caught up! There's nothing to display at the moment.",

  noUnreadTitle: "No unread notifications",
  noUnreadMessage: "You have read all your notifications.",

  types: {
    [NotificationType.expenseSubmitted]: {
      title: "Expense report submitted",
      message: "Your expense report has been submitted for approval.",
    },
    [NotificationType.expenseApproved]: {
      title: "Expense report approved",
      message: "Your expense report has been approved.",
    },
    [NotificationType.expenseRejected]: {
      title: "Expense report rejected",
      message: "Your expense report has been rejected.",
    },
    [NotificationType.expenseReimbursed]: {
      title: "Expense report reimbursed",
      message: "Your expense report has been reimbursed.",
    },
    [NotificationType.policyUpdated]: {
      title: "Policy updated",
      message: "Your expense category policy has been updated.",
    },
    [NotificationType.mileageRateUpdated]: {
      title: "Mileage rate updated",
      message: "The applicable mileage rate has been updated.",
    },
  } satisfies Record<NotificationType, { title: string; message: string }>,
},

 auth: {
    login:          "Sign in",
    loginTitle:     "Sign in",
    email:          "Email address",
    password:       "Password",
    required:   "Email is required",
    forgotPassword: "Forgot password?",
    resetPassword:  "Reset password",
    resetPasswordTitle: "Reset your password",
    resetPasswordSuccess: "Password reset email sent. Please check your inbox.",
    resetPasswordError: "Error sending password reset email. Please try again.",
    sendResetEmail: "Send reset email",
    backToLogin: "Back to login",
    noAccount:      "Don't have an account?",
    register:       "Sign up",
    loginError:     "Invalid email or password",
    or: "or",
    googleLogin: "Sign in with Google",
    signingIn: "Signing in...",
    subtitle: "Restricted to administrators",
    noAdminAccess: "You don't have permission to access the admin panel.",
    profileError: "Error fetching profile.",
    fillBothFields: "Please fill in both fields.",
    loginFailed: "Login failed.",
    incompleteUser: "User information is incomplete.",
    firebaseError: "Firebase error:",
    unknownError: "An error occurred",
  },

  errors: {
    required:     "This field is required",
    invalidEmail: "Invalid email",
    networkError: "Network error, please try again",
    unauthorized: "Session expired, please sign in again",
    notFound:     "Page not found",
  },

};

export default en;